/**
 * This file re-exports from src/utility/constants/.
 * All constants have been split into category files under src/utility/constants/.
 * This file is kept so that all existing imports continue to work without changes.
 */

import {
  getToken,
  getUsertypeFromLS,
  getUserIdFromLS,
  api_header_code,
  api_error_code,
  api_success_code,
  API_URL,
  Bucket,
  BASE_S3_URL,
  imgSvToken,
  $axios,
} from "./constants/api";

import {
  UserType,
  UserTypeObj,
  userRelated,
  storeRelated,
  storeStockRelated,
  stockTransferRelated,
  warehouseRelated,
  warehouseStockRelated,
  warehouseTransferRelated,
  productRelated,
  userSpecificPermissions,
  B2BUserAccess,
} from "./constants/userTypes";

import {
  response_alert,
  user_status,
  policy_status,
  POStatus,
  newPoEnum,
  newB2BPoEnum,
  B2B_PO_STATUS_ORDER,
  b2bPoStatusList,
} from "./constants/statusCodes";

import {
  gstSlab,
  insuranceCompany,
  storeType,
  LocationType,
  storageType,
  deliveryType,
  recipeOrIngredient,
  companyStates,
} from "./constants/storeConfig";

import {
  states,
  statesForStore,
  citiesForStore,
  cities,
} from "./constants/geography";

import { pdfLogo } from "./constants/pdfLogo";

// Named exports so existing "import { getToken } from './constant'" style imports continue to work
export {
  getToken,
  getUsertypeFromLS,
  getUserIdFromLS,
  api_header_code,
  api_error_code,
  api_success_code,
  API_URL,
  Bucket,
  BASE_S3_URL,
  imgSvToken,
  $axios,
  UserType,
  UserTypeObj,
  userRelated,
  storeRelated,
  storeStockRelated,
  stockTransferRelated,
  warehouseRelated,
  warehouseStockRelated,
  warehouseTransferRelated,
  productRelated,
  userSpecificPermissions,
  B2BUserAccess,
  response_alert,
  user_status,
  policy_status,
  POStatus,
  newPoEnum,
  newB2BPoEnum,
  B2B_PO_STATUS_ORDER,
  gstSlab,
  insuranceCompany,
  storeType,
  LocationType,
  storageType,
  deliveryType,
  recipeOrIngredient,
  companyStates,
  states,
  statesForStore,
  citiesForStore,
  cities,
  pdfLogo,
};

// Default export preserves the original constant object shape exactly
const constant = {
  API_URL,
  Bucket,
  BASE_S3_URL,
  apiUrl: process.env.REACT_APP_API_BASE_URL,
  insuranceCompany,
  storeType,
  UserType,
  storageType,
  deliveryType,
  LocationType,
  states,
  cities,
  axios: $axios,
  api_error_code,
  api_header_code,
  api_success_code,
  response_alert,
  user_status,
  policy_status,
  hasConnection: navigator.onLine,
  mainMenuLinksArray: ["/dashboard"],
  spaceRegex: /^\S*$/,
  // eslint-disable-next-line
  passwordRegex: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z0-9!_@./#&+-\d]{8,}$/,
  // eslint-disable-next-line
  emailRegex:
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  userRelated,
  storeRelated,
  storeStockRelated,
  stockTransferRelated,
  warehouseRelated,
  warehouseStockRelated,
  warehouseTransferRelated,
  productRelated,
  gstSlab,
  UserTypeObj,
  getUsertypeFromLS,
  getUserIdFromLS,
  statesForStore,
  citiesForStore,
  userSpecificPermissions,
  recipeOrIngredient,
  POStatus,
  newPoEnum,
  newB2BPoEnum,
  B2B_PO_STATUS_ORDER,
  imgSvToken,
  pdfLogo,
  companyStates,
  b2bPoStatusList,
  B2BUserAccess,
};

export default constant;
